var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("encryption-field", {
    attrs: {
      "field-name": _vm.fieldName,
      "encrypted-value": _vm.encryptedValue,
      label: _vm.label,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var value = ref.value
          return [
            !_vm.urls(value).length
              ? _c("span", [_vm._v(_vm._s(value ? "--" : "********"))])
              : _vm._e(),
            _vm._l(_vm.urls(value), function (url) {
              return _c("el-image", {
                key: url,
                staticStyle: { width: "50px", "margin-right": "5px" },
                attrs: {
                  src: url,
                  "preview-src-list": _vm.urls(value),
                  fit: "contain",
                },
              })
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }